// extracted by mini-css-extract-plugin
export default {"expiredClientJob":"bXb0U","expiredClientJobText":"zHK0L","expiredJobClientButton":"jd8ff","link":"Z7hOF"};